var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSemanticUi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1930_22375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H70V70H0V0Z",
    fill: "#34BDB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.062 23.7999C42.3662 21.6556 39.0855 19.9693 34.7936 20.0437C32.3381 20.0864 30.2299 21.421 29.7867 23.8636C29.3741 26.1362 31.3942 27.3967 33.4959 28.1705C36.9814 29.4541 40.0157 30.8092 43.4405 32.2363C49.6664 34.8309 52.8588 39.0328 52.4814 44.4242C52.0013 51.2839 47.8729 56.2039 41.3118 57.8259C32.7384 59.9456 24.4131 56.7169 17.3789 52.2095C19.1543 49.505 21.2141 47.6587 22.9789 44.9705C27.0427 46.7003 30.2354 49.0376 34.4868 49.4021C37.4845 49.6592 40.8811 49.5162 41.5546 45.9951C42.1616 42.82 39.3983 41.1178 36.703 40.1671C33.4942 39.0353 30.2914 37.6509 27.1447 36.3657C21.3279 33.9898 18.961 29.3428 19.3594 23.8683C19.3594 20.6584 22.0227 14.1705 28.5527 12.1526C38.5856 9.05179 44.1134 12.2269 51.3888 16.9025C49.4564 19.458 47.9708 21.275 46.062 23.7999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1930_22375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemanticUi);
export default __webpack_public_path__ + "static/media/semantic_ui.eaaf3e6d03e0b56f13e31396d8c7da60.svg";
export { ForwardRef as ReactComponent };